<template>
<div class="main flex flex-center flex-align-center">
  <div class="login flex flex-col">
    <img class="logo margin-bottom-20" src="../../assets/images/login/logo.png" alt="">
    <div class=" flex1 login-item bg-fff flex flex-around flex-align-center">
      <div class="item text-center">
<!--        <div class="font-18 font-bold margin-bottom-10">微信扫码登录</div>-->
<!--        <div class="font-14 font-info margin-bottom-10">使用微信扫一扫，扫描下方二维码</div>-->
<!--        <img class="qrcode" title="点击刷新二维码" :src="loginQR" alt="" @click="refreshQR">-->
<!--        <div v-if="timeoutFlag" class="font-warning ">二维码已失效，请点击二维码刷新</div>-->
      </div>
      <div class="item ">
        <div class="login-i flex flex-col flex-center flex-align-center">
          <div style="width: 340px" class="font-18 font-bold margin-bottom-20">会员管理系统</div>
            <el-input   prefix-icon="el-icon-user" class="inputBox margin-bottom-10"  v-model="phone" placeholder="请输入账号"></el-input>
              <el-input   prefix-icon="el-icon-key" class="inputBox margin-bottom-10" :show-password="true" type="password" v-model="passWord" placeholder="请输入密码"></el-input>
            <!--          <div class="blue" @click="getCode" >{{text}}</div>-->
          <el-button class="btn margin-bottom-10" type="primary" :disabled="disabled" @click="loginYKA">登录</el-button>
          <div style="width: 340px" class="flex flex-between">
            <el-checkbox v-model="checked">记住密码</el-checkbox>
            <div style="text-decoration: underline;color:#0071C2" @click="dialogVisible=true" class="pointer">忘记密码</div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <el-dialog
      title="忘记密码"
      :modal-append-to-body="false"
      :visible.sync="dialogVisible"
      width="500px"
  >
    <el-form v-model="form2" label-width="150px">
      <el-form-item label="手机号码：">
        <el-input size="small"
                  style="width: 180px"
                  clearable
                  v-model="form2.phone"
                  placeholder="请输入手机号码">
        </el-input>
      </el-form-item>
      <el-form-item label="新密码：" >
        <el-input size="small"
                  style="width: 180px"
                  clearable
                  type="password"
                  :show-password="true"
                  v-model="form2.password"
                  placeholder="请输入新密码">
        </el-input>
      </el-form-item>
      <el-form-item label="验证码：">
        <el-input size="small"
                  style="width: 180px"
                  clearable
                  v-model="form2.code"
                  placeholder="请输入手机号码">
        </el-input>
        <span class="blue" @click="getCode" >{{text}}</span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="agreeit">确 定</el-button>
      </span>
  </el-dialog>
</div>
</template>

<script>
export default {
  name: "login",
  data(){
    return {
      dialogVisible:false,
      checked:true,
      disabled:false,
      time:60,
      t:null,
      phone:'',
      passWord:undefined,
      form2:{},
      // key:undefined,
      // loginQR:undefined,
      // checkTimes:0,
      // timeoutFlag:false,
      text:'获取验证码',
      // stoptimeout:false
    }
  },
  mounted() {
    // this.key = this.uuid()
    if(localStorage.getItem('username')){
      this.phone=localStorage.getItem('username')
    }
    if(localStorage.getItem('password')){
      this.passWord=localStorage.getItem('password')
    }
  },
  watch:{
    // key(){
    //   this.checkTimes = 0
    //   this.timeoutFlag = false
    //   this.loginQR = this.getQrCode()
    //   this.check()
    // },
  },
  destroyed () {
    // this.stoptimeout=true
    if(this.t)clearInterval(this.t)
  },
  methods:{
    dialogClose(){
      this.form2={}
      this.dialogVisible=false
    },
    agreeit(){
      console.log(this.form2)
      this.$http.get('/rest/credentials/password/modify', this.form2,res => {
        this.$message.success('提交完成！')
        this.dialogClose()
      })
    },
    loginYKA() {
      if (!this.phone) {
        this.$message.error('请输入手机号！')
        return
      }
      if (!this.passWord) {
        this.$message.error('请输入密码！')
        return
      }
      this.disabled=true
      this.$http.post('/rest/credentials/login',{username:this.phone,password:this.passWord,deviceType:2},res=>{
        // location.href=this.$route.query.url
        // this.stoptimeout=true
        if(this.checked){
          localStorage.setItem('username',this.phone)
          localStorage.setItem('password',this.passWord)
        }else{
          localStorage.removeItem('username')
          localStorage.removeItem('password')
        }
        this.$router.push('/activity')
      },(err)=>{
        this.disabled=false
      })
    },
    timeout() {
      // debugger
      if (this.time > 0) {
        this.time--
        this.text=this.time + 's后获取'
      } else {
        this.text='获取验证码'
        this.time = 60
        clearInterval(this.t)
      }
    },
    getCode() {
      if (!this.form2.phone) {
        this.$message.error('请输入手机号！')
        return
      }
      if(this.text!='获取验证码'){
        return;
      }
      this.text=this.time + 's后再获取'
      this.t = setInterval(this.timeout, 1000)
      this.$http.post('/rest/credentials/password/getver',{phone:this.form2.phone},res=>{
      })
    },
    // getQrCode(){
    //   return "/service-fire-qa/credentials/generator/qrcode/"+this.key
    // },
    // refreshQR(){
    //   this.key = this.uuid()
    // },
    // check () {
    //   this.checkTimes++
    //   // console.log(this.checkTimes)
    //   // 如果超过3分钟没有扫码
    //   if (this.checkTimes < 60) {
    //     let url = '/service-fire-qa/credentials/qrcode/check?key=' + this.key
    //     this.$http.get(url, null, res => {
    //       if (res=== 'scan') {
    //         this.$message.success('扫码登录成功')
    //         this.$router.push('/')
    //       } else if (res=== 'no-scan') {
    //         if(!this.stoptimeout){
    //           setTimeout(this.check, 1000)
    //         }
    //       }
    //     })
    //   }else{
    //     this.timeoutFlag = true
    //   }
    // },
  }
}
</script>

<style scoped>
.login-i{
  background-color: #fff;
  border-radius: 10px;
  width: 480px;
  height: 370px;

}
.blue{
  color:#4680FE;
  cursor: pointer;
}
i{
  color: #A8AFBE ;
}
.btn{
  width: 340px;
}
input{
  color:#666
}
.li{
  color: #333;
  height: 16px;
  line-height: 16px;
  border-right: 1px solid #999;
  padding-right: 10px;
}
.main{
  position: fixed;
  width: 100%;
  min-width: 1100px;
  height: 100%;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 2001;
  /*background-image: url("../../assets/images/login/wx_web_dl_bg.png");*/
}
.line{
  width: 1px;
  height: 300px;
  background: #D8D8D8 ;
}
.item{
  width: 50%;
  /*height: 300px;*/
}
.qrcode{
  width: 170px;
  height: 170px;
  cursor: pointer;
}
.logo{
  width: 236px;
  height: 48px;
  margin-left: 15%;
}
.login{
  width: 100%;
  height: 80%;
}
.login-item{
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/login/bg.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.inputBox{
  width: 340px;
  height: 50px;
  line-height: 50px;

}
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue